import React from 'react';
import { activePromo, formatPrice } from '../helpers/utils';
import { IPlan } from '../store/Quote';

const articleClass = (grid: boolean): string =>
  grid ? 'col-12 col-sm-12 col-md-6 col-lg-5 col-xl-4' : 'col-12';

const containerClass = (grid: boolean, promoExtended: boolean): string =>
  grid
    ? 'product-card'
    : promoExtended
    ? 'product-card product-card--line align-items-center pt20 pb20'
    : 'product-card product-card--line align-items-center pt20 pb20';

const headerClass = (grid: boolean, promoExtended: boolean): string =>
  grid ? (promoExtended ? '' : '') : 'd-none';

const firstSectionClass = (grid: boolean): string =>
  grid ? '' : 'col-sm-3 text-left';

const spanClass = (grid: boolean): string =>
  grid ? 'd-none' : 'text-near-black';

const secondh3Class = (grid: boolean): string =>
  grid ? 'product-card--price mt20' : 'd-none';

const pClass = (grid: boolean): string =>
  grid ? 'text-dark-gray px-18' : 'd-none';

const secondSectionClass = (grid: boolean): string =>
  grid ? '' : 'col-sm-6 text-left';

const thirdSectionClass = (grid: boolean): string =>
  grid ? 'd-none' : 'd-block col-12 col-sm-3';

const promoSection = (grid: boolean, promoExtended: boolean): string =>
  grid
    ? promoExtended
      ? 'col-12 mb20'
      : 'd-none'
    : promoExtended
    ? 'col-5 mx-auto'
    : 'd-none';

const footerClass = (grid: boolean): string => (grid ? '' : 'd-none');

interface IPlanProps {
  plan_id: string;
  plan_name: string;
  premium: string;
  premium_monthly: number;
  selectPlan: (payload: IPlan) => any;
  grid: boolean;
  [key: string]: any;
  death: string;
  sickness: string;
  accident: string;
}

export default function Plan(props: IPlanProps) {
  const {
    selectPlan,
    plan_id,
    plan_name,
    premium,
    premium_monthly,
    grid,
    death,
    accident,
    sickness,
  } = props;
  const select = () =>
    selectPlan({
      accident,
      death,
      name: plan_name,
      plan_id,
      premium,
      premium_monthly,
      sickness,
    });

  const promo = activePromo();

  return (
    <article className={articleClass(grid)}>
      <div className={containerClass(grid, promo)}>
        <header className={headerClass(grid, promo)}>{plan_name}</header>
        <section className={firstSectionClass(grid)}>
          <span className={spanClass(grid)}>{plan_name}</span>
          <h3 className={secondh3Class(grid)}>
            <img
              src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money.svg"
              alt="Simbolo de peso"
              width="20px"
            />
            {formatPrice(premium_monthly)}
          </h3>
          <p className={pClass(grid)}>Mensuales</p>
          <div className={`w-100 border-bottom mb20 ${grid ? '' : 'd-none'}`} />
        </section>

        <section className={secondSectionClass(grid)}>
          <div className="row">
            <div className="col-12">
              <p className="mb0 text-light">
                Suma Asegurada por Muerte Accidental
              </p>
              <p className="mb0 text-green">
                <img
                  src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money-green.svg"
                  alt="Simbolo de peso"
                  width="9px"
                />
                {death}
              </p>
              <div className={`w-100 mb20 mt20${grid ? ' border-bottom' : ''}`} />
              <p className="mb0 text-light">
                Suma Asegurada Hospitalización por Accidente
              </p>
              <p className="mb0 text-green">
                <img
                  src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money-green.svg"
                  alt="Simbolo de peso"
                  width="9px"
                />
                {accident}
              </p>
              <div className={`w-100 mb20 mt20${grid ? ' border-bottom' : ''}`} />
              <p className="mb0 text-light">
                Suma Asegurada Hospitalización por Enfermedad
              </p>
              <p className="mb0 text-green">
                <img
                  src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money-green.svg"
                  alt="Simbolo de peso"
                  width="9px"
                />
                {sickness}
              </p>
            </div>
            <div className={`w-100 mb40 ${grid ? '' : 'd-none'}`} />
          </div>
        </section>

        <section className={promoSection(grid, promo)}>
          {grid ? (
            <img
              className="img-fluid w-50"
              src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/promo-60-en-giftcards.svg"
              alt="Promoción"
            />
          ) : (
            <img
              className="img-fluid w-40"
              src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/promo-60-en-giftcards.svg"
              alt="Promoción"
            />
          )}
        </section>

        <section className={thirdSectionClass(grid)}>
          <div className="row">
            <div className="col-12">
              <h3 className="product-card--price px-40 line-height-normal mb0">
                <img
                  src="//sfestaticos.blob.core.windows.net/pmc/vida/assets/svg/money.svg"
                  alt="Simbolo de peso"
                  width="20px"
                />
                {formatPrice(premium_monthly)}
              </h3>
              <p className={pClass(grid)}>Mensuales</p>
            </div>
            <div className="col-10 float-right">
              <button
                className="btn primary px-14 matrix-button"
                type="button"
                onClick={select}
              >
                Quiero contratar
              </button>
            </div>
          </div>
        </section>
        <footer className={footerClass(grid)}>
          <button
            className="btn white btn--hover-primary matrix-button"
            type="button"
            onClick={select}
          >
            Quiero contratar
          </button>
        </footer>
      </div>
    </article>
  );
}
